var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageContent"},[(_vm.Storage.get('code') != 2 && _vm.Storage.get('examStatus') != 1)?_c('inspectionReportStemp'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }